
export default {
  name: "AboutLeisureCraft",
  props: {
    settings: { type: Object, required: true },
  },
  computed: {
    eyebrow() {
      return this.settings.aboutEyebrowLabel || "About LeisureCraft";
    },
  },
};
